import { useQuery } from 'react-query';

import Auth from 'src/services/api/auth/Auth';
import { queryKeys } from 'src/services/api/constants';

export const useLoggedInUser = (disabled?: boolean, accessToken?: string) => {
    return useQuery(
        [queryKeys.loggedInUser],
        async () => Auth.getLoggedInUser(accessToken),
        { enabled: !disabled, retry: false, refetchOnWindowFocus: false }
    );
};
